import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { DoubleColumnMasonryLayout } from './components';
import * as style from './SearchResultsLayout.css';

export interface ISearchResultsLayoutProps extends React.PropsWithChildren {
  showMoreButton: React.ReactNode;
  isEmptyResult?: boolean;
}

export const SearchResultsLayout: React.FC<ISearchResultsLayoutProps> = props => {
  const { children, isEmptyResult = false, showMoreButton } = props;

  return (
    <div className={style['container']} data-testid="SearchResultsLayout">
      <div className={style['content']}>
        <Responsive desktop>
          {isEmptyResult ? children : <DoubleColumnMasonryLayout>{children}</DoubleColumnMasonryLayout>}
        </Responsive>
        <Responsive tablet phone>
          {children}
        </Responsive>
      </div>
      <div className={style['show_more_button']}>{showMoreButton}</div>
    </div>
  );
};
